import React, { useEffect, useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { getSession, processStrWithSpaceAndSpecalChars, valdiatePage } from '../../global';
import { getSubAaccounts, saveSubAccount, saveSubAccountLogo, getLocations, getSubAccountApprovalStatuses } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import Pagination from '../../components/paginations';
import SeeMoreModal from '../../components/SeeMoreModal';
import axios from 'axios';


const SubAccount = () => {
    const dispatch = useDispatch();
    const { userInfo, accounts } = useSelector(state => state.appData);
    const history = useHistory();

    const d = {
        accountNo: '',
        shipperName: '',
        shipperAddress: '',
        // autoCN: true,
        logo_base64: '',
        logo_status: false,
        locations: [],
        isActive: false
    };

    const [data, setData] = useState(d);
    const [isList, setIsList] = useState(true);
    const [grid, setGrid] = useState([]);
    const [viewType, setViewType] = useState('list');
    const [selectedBgImage, setSelectedBGImage] = useState(null);
    const [updateB, setUpdateB] = useState(false);
    const [locations, setLocations] = useState([]);

    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    const [approvalStatuses, setApprovalStatuses] = useState([]);
    
    const searchObjInit = {
        shipperName: '',
        shipperAddress: ''
    };

    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => {
        setSearchObj(prev => { return { ...prev, [key]: val } });

    }
    const gridKeys = [
        {key: 'accountNo', name: 'Account No', searchBox: false, visible: true},
        {key: 'shipperName', name: 'Shipper Name', searchBox: true, visible: true},
        {key: 'shipperAddress', name: 'Shipper Address', searchBox: true, visible: true},
        //{key: 'autoCN', name: 'Auto CN', searchBox: false, visible: true},
        {key: 'userId', name: 'User ID', searchBox: false, visible: true},
        {key: 'isActive', name: 'Is Active', searchBox: false, visible: true},
        {key: 'isDefault', name: 'Default', searchBox: false, visible: true},
        {key: 'approvalStatus', name: 'Approval Status', searchBox: false, visible: true},
        {key: 'rejectReason', name: 'Reject Reason', searchBox: false, visible: true},
        {key: 'lastActionBy', name: 'Last Action By', searchBox: false, visible: true},
        {key: 'lastActionDateTime', name: 'Last Action Date', searchBox: false, visible: true},
        {key: '', name: <b>Action</b>, searchBox: false, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

    useEffect(() => {
        if (valdiatePage('/subaccount')) {

        } else {
            history.push('/login');
        }
        return () => {

        }
    }, []);

    const getAccountsLocations = (accountNo) => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        setData(prev => ({ ...prev, accountNo, locations: [] }))
        if (accountNo) {
            getLocations(userInfo.id, accountNo, source).then(rs => {
                setLocations(rs);
            });
        } else {
            setLocations([])
        }
    }

    useEffect(() => {
        if (viewType == "list") {
            (async function () {
                dispatch(setLoading({ data: true }));
                const rs2 = await getSubAccountApprovalStatuses();
                const rs = await getSubAaccounts(userInfo.id, false);
                dispatch(setLoading({ data: false }));
                if (rs2.ok) {
                    setApprovalStatuses(rs2.data);
                }
                if (rs.ok) {
                    setGrid(rs.data.map(e => e.info));
                    setOriginalGrid(rs.data.map(e => e.info));
                }
            }())
        }
    }, [viewType])

    function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[arr.length - 1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      }
    

    const onEdit = async (x) => {
        getAccountsLocations(x.accountNo)
        setData(prev => {
            return {
                ...prev,
                Id: x.subAccountId,
                accountNo: x?.accountNo,
                shipperName: x?.shipperName,
                shipperAddress: x?.shipperAddress,
//                autoCN: x?.autoCN,
                logo_base64: x?.logo_base64,
                logo_status: x?.logo_status,
                locations: x?.locationId,
                isActive: x?.isActive,
                approvalStatus: x?.approvalStatus
            }
        })
        if (x?.logo_base64) {
            var file = dataURLtoFile(
              `data:text/plain;base64,${x?.logo_base64}`,
              "hello.jpeg"
            );
            setSelectedBGImage(file);
            setUpdateB(true);
          } else {
            setSelectedBGImage(null);
            setUpdateB(false);
          }
        setViewType('edit')
    }

    const onSaveLogo = async () => {
    
        if (!data.Id) {
          alert("Something went wrong.");
          return;
        }

        if (!data.accountNo) {
            alert('Select Account No');
            return;
        }

        if (!data.shipperName) {
            alert('Enter Shipper Name');
            return;
        }

        if (!data.shipperAddress) {
            alert('Enter Shipper Address');
            return;
        }

        if (data.locations.length === 0) {
            alert('Select at least one location.')
            return;
        }

        const formData = new FormData();
        formData.append("SubAccountId", data.Id);
        formData.append("imageFile", selectedBgImage);

        formData.append("shipperName", data.shipperName);
        formData.append("shipperAddress", data.shipperAddress);
        //formData.append("autoCN",  data.autoCN);
        formData.append("isActive", data.isActive);
        //formData.append("locationId", data.locations.map(l => l.locationId));
        data.locations.forEach(l => {
            formData.append("locationId", Number(l.locationId));
        });

        // formData.append("subAccountId", data.subAccountId);
        formData.append("userId", userInfo.id);
        formData.append("AccountNo", data.accountNo);


    
        dispatch(setLoading({ data: true }));
        const rs = await saveSubAccountLogo(formData);
        dispatch(setLoading({ data: false }));
        alert(rs.msg);
        if (rs.ok) {
          setData(d);
          setSelectedBGImage(null);
          setViewType("list");
        }
    };
    
    const onAdd = () => {
        // setLocations([])
        setViewType('add')
        setData(d)
    }

    const updateData = (key, val) => {
        setData({ ...data, [key]: val });
    }

    const onSave = async () => {
        if (!data.accountNo) {
            alert('Select Account No');
            return;
        }

        if (!data.shipperName) {
            alert('Enter Shipper Name');
            return;
        }

        if (!data.shipperAddress) {
            alert('Enter Shipper Address');
            return;
        }



        const formData = new FormData();
        formData.append("ShipperName", data.shipperName);
        formData.append("ShipperAddress", data.shipperAddress);
        formData.append("AccountNo", data.accountNo);
        //formData.append("AutoCN", data.autoCN);
        formData.append("CreatedBy", userInfo.id);
        formData.append("imageFile", selectedBgImage);
        // formData.append("isActive", data.isActive);
        //formData.append("locations", JSON.stringify(data.locations.map(Number)));
        data.locations.forEach(location => {
            formData.append("locations", Number(location));
        });

        const rs = await saveSubAccount(formData);
        alert(rs.msg);
        if (rs.sts == 0) {
            setData(d);
            setViewType('list')
            setSelectedBGImage(null);
        }
    }

    const approvalStatusMap = Object.fromEntries(
        approvalStatuses.map(x => [x.Id, x.Status])
    );


    return userInfo && <section className="section">
        {
            viewType === 'list' ?
            <>
                    <div className="section-header">
                        <h1>Sub Accounts</h1>
                    </div>
                    <div className="card" style={{ padding: 10 }}>
                        {
                            originalGrid && originalGrid.length > 0 &&
                            <>
                                <div style={{ textAlign: 'right' }}><button type='button' className='btn btn-sm btn-primary' onClick={() => onAdd()}>Add Sub Account</button></div>
                                
                                <Pagination
                                    setGrid={setGrid}
                                    searchObjInit={searchObjInit}
                                    searchObject={searchObject}
                                    originalGrid={originalGrid}
                                    setPage={setPage}
                                    setPageLimit={setPageLimit}
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    updateSearchData={updateSearchData}
                                    sortedArray={sortedArray}
                                    data={data}
                                    dataCount={grid.length}
                                    pageLimit={pageLimit}  
                                    gridKeys={gridKeys}
                                    page={page}
                                    grid={
                                        sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                            <tr key={index}>
                                                <td>{(index + 1)+(page*pageLimit)}</td>
                                                <td>{x?.accountNo}</td>
                                                <td>{x?.shipperName}</td>
                                                <td style={{ minWidth: 200 }}>
                                                    <SeeMoreModal detail={x?.shipperAddress} maxLength={80} />
                                                </td>
                                                {/* <td>{x?.autoCN ? 'Yes' : 'No'}</td> */}
                                                <td>{x?.userId}</td>
                                                <td>{x?.isActive ? 'Active' : 'InActive'}</td>
                                                <td>{x?.isDefault ? 'YES' : 'NO'}</td>
                                                <td>{approvalStatusMap[x?.approvalStatus] || ''}</td>
                                                <td>
                                                    <SeeMoreModal detail={x?.lastRemarks || ''} maxLength={80} />
                                                </td>
                                                <td>
                                                    {x?.lastActionBy}
                                                </td>
                                                <td>
                                                    {x?.lastActionDateTime}
                                                </td>
                                                <td><button type='button' className='btn btn-sm btn-primary' onClick={() => onEdit(x)}>Edit</button></td>
                                            </tr>
                                        )
                                    }
                                />
                            </>
                        }
                    </div>
                </>
                : viewType === 'edit' ?
                <>
                    <div className="section-header">
                        <h1>Sub Account</h1>
                    </div>
                    <div className="card" style={{ padding: 10 }}>
                        <div style={{ textAlign: 'right' }}><button type='button' className='btn btn-sm btn-primary' onClick={() => { 
                            setViewType('list')
                            setSelectedBGImage(null)
                        }}>Back</button></div>
                        <div className="row">
                                <div className="col-lg-3 col-sm-12">
                                    <label>Shipper Name</label>
                                    <input type="text" className="form-control" onInput={processStrWithSpaceAndSpecalChars} maxLength={49} disabled={data.approvalStatus == 4 ? true : data.isActive == true ? true : false} value={data.shipperName} onChange={e => updateData('shipperName', e.target.value)} />
                                </div>
                                <div className="col-lg-9 col-sm-12">
                                    <label>Shipper Address</label>
                                    <textarea className="form-control" maxLength={255} disabled={data.approvalStatus == 4 ? true : data.isActive == true ? true : false}  value={data.shipperAddress} onChange={e => updateData('shipperAddress', e.target.value)}></textarea>
                                </div>
                                {/* <div className="col-lg-3 col-sm-12">
                                    <label style={{ display: 'block' }}>Auto Consignment</label>
                                    <label className="switch">
                                        <input type="checkbox" checked={data.autoCN} onChange={e => updateData('autoCN', e.target.checked)} />
                                        <span className="slider round"></span>
                                    </label>
                                </div> */}
                                {/* <div className="col-lg-3 col-sm-12">
                                    <label style={{ display: 'block' }}>Active</label>
                                    <label className="switch">
                                        <input type="checkbox" checked={data.isActive} onChange={e => updateData('isActive', e.target.checked)} />
                                        <span className="slider round"></span>
                                    </label>
                                </div> */}
                                <div className="row mt-4 section-border">
                                    <label>Locations</label>

                                    {
                                        locations.map((e, i) => <div key={i} className="col-lg-3 col-sm-12">
                                            <label className="small-switch">
                                                <input type="checkbox" name={e.name} value={e.value} checked={data.locations.map(l => l.locationId).includes(Number(e.value))} onChange={c => {
                                                    let updatedLocations = [];
                                                    if (c.target.checked) {
                                                        updatedLocations = [...data.locations, { locationId: Number(e.value) }]
                                                    } else {
                                                        updatedLocations = data.locations.filter((item) => { return Number(e.value) !== item.locationId })
                                                    }
                                                    updateData('locations', updatedLocations);
                                                }} />
                                                <span className="small-slider round"></span>
                                            </label>
                                            <label className="small-content-check">{e.text}</label>
                                        </div>)
                                    }

                                </div>
                            </div>
                        <div className="row">
                            <div className="col-lg-6 col-sm-12">
                                <div className="col-lg-6 col-sm-12">
                                    <label style={{ whiteSpace: "nowrap", marginLeft: '12px' }}>
                                        Upload Logo Image | Allowed File Type: jpg, jpeg, .png | Max Image Size 20kb.
                                    </label>
                                    
                                </div>
                                {selectedBgImage && (
                                <div className="col-lg-6 col-sm-12 mt-3" style={{marginLeft: '12px'}}>
                                    {/* <label>Display and Upload Background Image</label> */}
                                    <div>
                                        <img
                                            alt="Bg Image"
                                            width={"250px"}
                                            src={URL.createObjectURL(selectedBgImage)}
                                        />
                                        <br />
                                        <button onClick={() =>{
                                             setSelectedBGImage(null);
                                        }}>
                                            Remove
                                        </button>
                                    </div>
                                </div>
                                )}
                                <div className="col-lg-6 col-sm-12 mt-3">

                                    <input
                                        type="file"
                                        name="myImage"
                                        style={{padding: '0 !important'}}
                                        onChange={(e) => {
                                        var fileInput = e;
                                        var filePath = e.target.value;
                                        // Allowing file type
                                        var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
                                        if (!allowedExtensions.exec(filePath)) {
                                            alert("Invalid file type");
                                            fileInput.target.value = "";
                                            return false;
                                        }

                                        const fi = e.target;
                                        // Maximum file size is 20 kb
                                        if (fi.files.length > 0) {
                                            for (let i = 0; i <= fi.files.length - 1; i++) {
                                                const fsize = fi.files.item(i).size;
                                                const file = Math.round(fsize / 1024);
                                                // The size of the file.
                                                if (file >= 20) {
                                                    alert(
                                                        "Maximum File size is 20kb."
                                                    );
                                                    return false;
                                                }
                                            }
                                        }

                                        setUpdateB(true);
                                        setSelectedBGImage(e.target.files[0]);
                                    }}
                                    />
                                </div>
                                
                            </div>
                            <div className="col-lg col-sm-12" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', marginTop: '20px' }}>
                                <button type="button" className="btn btn-primary"  onClick={onSaveLogo}>Update</button>
                            </div>
                        </div>
                    </div>
                </>
                :
                <>
                   <div className="section-header">
                        <h1>Sub Account</h1>
                    </div>
                    <div className="card" style={{ padding: 10 }}>
                        <div style={{ textAlign: 'right' }}><button type='button' className='btn btn-sm btn-primary' onClick={() => { 
                            setViewType('list')
                            setSelectedBGImage(null)
                        }}>Back</button></div>
                        <div className="row">
                            <div className="col-lg-2 col-sm-12">
                                <label>Account No</label>
                                <select className="form-select" value={data.accountNo} onChange={e => getAccountsLocations(e.target.value)}>
                                    <option value="">Select Account No</option>
                                    {
                                        accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                                    }
                                </select>
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <label>Shipper Name</label>
                                <input type="text" className="form-control" value={data.shipperName} onChange={e => updateData('shipperName', e.target.value)} />
                            </div>
                            <div className="col-lg-3 col-sm-12">
                                <label>Shipper Address</label>
                                <textarea className="form-control" value={data.shipperAddress} onChange={e => updateData('shipperAddress', e.target.value)}></textarea>
                            </div>
                            {/* <div className="col-lg-1 col-sm-12">
                                <label style={{ whiteSpace: 'nowrap' }}>Auto Consignment</label>
                                <label className="switch">
                                    <input type="checkbox" checked={data.autoCN} onChange={e => updateData('autoCN', e.target.checked)} />
                                    <span className="slider round"></span>
                                </label>
                            </div> */}


                            <div className={`row mt-4 ${locations.length > 0 ? 'section-border' : undefined} `}>
                                    {locations.length > 0 && <label>Locations</label>}

                                    {
                                        locations.map((e, i) => <div key={i} className="col-lg-3 col-sm-12">
                                            <label className="small-switch">
                                                <input type="checkbox" name={e.name} value={e.value} checked={data.locations.includes(Number(e.value))} onChange={c => {
                                                    let updatedLocations = [];
                                                    if (c.target.checked) {
                                                        updatedLocations = [...data.locations, Number(e.value)]
                                                    } else {
                                                        updatedLocations = data.locations.filter((item) => { return Number(e.value) !== item })
                                                    }
                                                    updateData('locations', updatedLocations);
                                                }} />
                                                <span className="small-slider round"></span>
                                            </label>
                                            <label className="small-content-check">{e.text}</label>
                                        </div>)
                                    }

                            </div>
                            
                            <div className="row">
                            <div className="col-lg-6 col-sm-12">
                                <div className="col-lg-6 col-sm-12">
                                    <label style={{ whiteSpace: "nowrap", marginLeft: '12px' }}>
                                        Upload Logo Image | Allowed File Type: jpg, jpeg, .png | Max Image Size 20kb.
                                    </label>
                                    
                                </div>
                                {selectedBgImage && (
                                <div className="col-lg-6 col-sm-12 mt-3" style={{marginLeft: '12px'}}>
                                    {/* <label>Display and Upload Background Image</label> */}
                                    <div>
                                        <img
                                            alt="Bg Image"
                                            width={"250px"}
                                            src={URL.createObjectURL(selectedBgImage)}
                                        />
                                        <br />
                                        <button onClick={() => setSelectedBGImage(null)}>
                                            Remove
                                        </button>
                                    </div>
                                </div>
                                )}
                                <div className="col-lg-6 col-sm-12 mt-3">

                                    <input
                                        type="file"
                                        name="myImage"
                                        style={{padding: '0 !important'}}
                                        onChange={(e) => {
                                        var fileInput = e;
                                        var filePath = e.target.value;
                                        // Allowing file type
                                        var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
                                        if (!allowedExtensions.exec(filePath)) {
                                            alert("Invalid file type");
                                            fileInput.target.value = "";
                                            return false;
                                        }

                                        const fi = e.target;
                                        // Maximum file size is 20 kb
                                        if (fi.files.length > 0) {
                                            for (let i = 0; i <= fi.files.length - 1; i++) {
                                                const fsize = fi.files.item(i).size;
                                                const file = Math.round(fsize / 1024);
                                                // The size of the file.
                                                if (file >= 20) {
                                                alert(
                                                    "Mazimum file size is 20kb."
                                                );
                                                return false;
                                                }
                                            }
                                        }

                                        setSelectedBGImage(e.target.files[0]);
                                    }}
                                    />
                                </div>
                                
                            </div>
                           
                        </div>

                            <div className="col-lg col-sm-12" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                <button type="button" className="btn btn-primary" onClick={onSave}>Save</button>
                            </div>
                        </div>
                    </div>
                </>
        }

    </section>
}

export default SubAccount